module.exports = __webpack_public_path__ + "img/alarm1.ef898c38.png";